//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Child_Pugh",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
      },
      item1List: [
        { value: '1', name: '<2 mg/dL(<34 µmol/L)' },
        { value: '2', name: '2-3 mg/dL (34-50 µmol/L)' },
        { value: '3', name: '>3 mg/dL (>50 µmol/L)' },
      ],
      item2List: [
        { value: '1', name: '>3.5 g/dL (>35 g/L)' },
        { value: '2', name: '2.8-3.5 g/dL (28-35 g/L)' },
        { value: '3', name: '<2.8 g/dL (<28 g/L)' },
      ],
      item3List: [
        { value: '1', name: '<1.7' },
        { value: '2', name: '1.7-2.2' },
        { value: '3', name: '>2.2' },
      ],
      item4List: [
        { value: '1', name: '无腹水' },
        { value: '2', name: '能够控制的腹水(轻度)' },
        { value: '3', name: '难以控制的腹水(重度)' },
      ],
      item5List: [
        { value: '1', name: '无脑病' },
        { value: '2', name: '能够控制的脑病(I~II)' },
        { value: '3', name: '难以控制的脑病(III~IV)' },
      ],
      title: '',
      text: ''
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
        if (result < 7) {
          self.title = 'A级'
          self.text = '患者的一年和两年生存率：100%和85%'
        } else if (result < 10) {
          self.title = 'B级'
          self.text = '患者的一年和两年生存率：80%和60%'
        } else if (result < 16) {
          self.title = 'C级'
          self.text = '患者的一年和两年生存率：45%和35%'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Child_Pugh.vue